var render = function (_h,_vm) {var _c=_vm._c;return _c('EbxCoreRecommendations',{attrs:{"type":"emptySearch"}})}
var staticRenderFns = []

export { render, staticRenderFns }